var map = {
  "./uk.json": [
    "840359",
    "615170"
  ],
  "./boxes.json": [
    "370924",
    "72393"
  ],
  "./el.json": [
    "508446",
    "229613"
  ],
  "./en-pt.json": [
    "885571",
    "891682"
  ],
  "./lv.json": [
    "949561",
    "258880"
  ],
  "./sr.json": [
    "19654",
    "327780"
  ],
  "./accents.json": [
    "159736",
    "805788"
  ],
  "./extra.json": [
    "162903",
    "413169"
  ],
  "./hi.json": [
    "859880",
    "131821"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 802444;
module.exports = webpackAsyncContext;
